<button
  class="tab-container"
  type="button"
  [attr.data-content]="content"
  [attr.data-size]="size"
  [attr.data-active]="active"
  [attr.data-disabled]="disabled"
  [attr.data-hover]="hover"
  [attr.data-fullWidth]="fullWidth"
  [disabled]="disabled"
  [attr.aria-selected]="active"
  [attr.role]="'tab'"
  (click)="onTabClick()"
>
  <!-- Icon (conditional based on content variant) -->
  <span class="tab-icon" *ngIf="showIcon" aria-hidden="true">
    <umss-icon [name]="iconName!" [size]="iconSize"></umss-icon>
  </span>

  <!-- Label (conditional based on content variant) -->
  <span class="tab-label" *ngIf="showLabel">{{ label }}</span>

  <!-- Counter (optional) -->
  <span class="tab-counter" *ngIf="showCounter && counter">
    {{ counterDisplay }}
  </span>
</button>
